const CareersPage = () => {
    return <div>Careers Page</div>;
};

export default CareersPage;
